import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import classes from './NavG.module.scss';

const NavG = (props) => {
  const {
    header, subHeader, iconLinks = [],
  } = props;

  return (
    <div className={classes.container}>
      {header &&
        <div
          className={classes.header}
          dangerouslySetInnerHTML={{ __html: header }}
        />}
      {subHeader &&
        <div
          className={classes.subHeader}
          dangerouslySetInnerHTML={{ __html: subHeader }}
        />}
      {iconLinks.length > 0 &&
        <div className={classes.navs}>
          {iconLinks.map((navLink, i) => {
            const { title: navTitle, icon, href: navHref, target: navTarget } = navLink;
            return (
              <div className={classes.nav} key={i}>
                <Button
                  subType='ButtonD'
                  title={navTitle}
                  leftIcon={icon}
                  rightIcon='far fa-chevron-right'
                  href={navHref}
                  target={navTarget}
                  className={classes.navButton}
                />
              </div>
            );
          })}
        </div>}
    </div>
  );
};

NavG.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  subHeader: PropTypes.string,
  /**
   * A list of iconLinks that display directly below the subHeader
  */
  iconLinks: PropTypes.array,
};

export default NavG;
